(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddOnlineLesson", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddOnlineLessonView.html",
            controller: ["$scope", "$localStorage", "notify", "Upload", "$timeout", LearningItemAddOnlineLessonCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddOnlineLessonCtrl($scope, $localStorage, notify, Upload, $timeout) {
            var vm = this;
            vm.$onInit = function () {
                vm.maxFilesAllowed = 1;
                if (!vm.wizard.formData.specificInfo.fileName) {
                    vm.wizard.formData.specificInfo.fileName = "";
                    if ($localStorage.learningItemAddOnlineLessonWindowWidth)
                        vm.wizard.formData.specificInfo.windowWidth = $localStorage.learningItemAddOnlineLessonWindowWidth;
                    else
                        vm.wizard.formData.specificInfo.windowWidth = 1024;
                    if ($localStorage.learningItemAddOnlineLessonWindowHeight)
                        vm.wizard.formData.specificInfo.windowHeight = $localStorage.learningItemAddOnlineLessonWindowHeight;
                    else
                        vm.wizard.formData.specificInfo.windowHeight = 768;
                }
            };
            ///////////////////////////////////////////////////////////////////////
            vm.upload = function (file) {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningitems/temp/online-lesson",
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            for (var attrname in response.data) {
                                if (response.data.hasOwnProperty(attrname)) {
                                    vm.wizard.formData.specificInfo[attrname] = response.data[attrname];
                                }
                            }
                            $scope.$apply();
                            notify({
                                "messageTemplate": "<span translate='common.dropzone.uploadedFileMessage'></span>", "classes": "alert-success"
                            });
                            vm.progress = 0;
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                            notify({
                                "messageTemplate": "<span data-translate>" + error + "</span>", "classes": "alert-danger"
                            });
                        }
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.saveWindowDimensions = function () {
                $localStorage.learningItemAddOnlineLessonWindowWidth = parseInt(vm.wizard.formData.specificInfo.windowWidth, 10);
                $localStorage.learningItemAddOnlineLessonWindowHeight = parseInt(vm.wizard.formData.specificInfo.windowHeight, 10);
            };
            vm.removeFile = function () {
                vm.wizard.formData.specificInfo.fileName = "";
                vm.wizard.formData.specificInfo.fileUrl = "";
                vm.wizard.form.$valid = false;
                vm.wizard.formData.specificInfo.possibleLaunchFiles = [];
            };
            vm.validateFile = function (file) {
                if (file) {
                    if (vm.wizard.formData.specificInfo.fileName) {
                        return "maxFiles";
                    }
                    return true;
                }
                return false;
            };
        }
    });
}());
